import type { VideoModel } from '@/shared/generated'

import { find, propEq } from 'lodash/fp'

import { useVideoTutorialsQuery } from '../api/queries'

export const useVideoTutorial = (id: string) =>
	useVideoTutorialsQuery<VideoModel>({
		select: find(propEq('id', id)),
	})
